import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Checkbox, Tabs } from "antd"
import React from "react"
import { t } from "~/languages/i18n"
interface PagesComponentProps {
  expandedPages: boolean
  togglePagesExpand: () => void
  subTab: string
  handleSubTabChange: (key: string) => void
  mostRecentPages: { name: string }[]
  checkedItems: string[]
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void
  handlePageSelectAll: () => void
  addToMenu: () => void
}

const PagesItem: React.FC<PagesComponentProps> = ({
  expandedPages,
  togglePagesExpand,
  subTab,
  handleSubTabChange,
  mostRecentPages,
  checkedItems,
  handleCheckboxChange,
  handlePageSelectAll,
  addToMenu,
}) => {
  return (
    <div className="border">
      <div className="flex justify-between p-[10px] text-base font-medium" onClick={togglePagesExpand}>
        <p>{t("Pages")}</p>
        <p>{expandedPages ? <CaretUpOutlined /> : <CaretDownOutlined />}</p>
      </div>
      <div
        className={`px-[10px] t-2 transition-all duration-300 ${
          expandedPages ? "max-h-[400px] overflow-hidden" : "max-h-0 overflow-hidden"
        }`}
      >
        <Tabs
          onChange={handleSubTabChange}
          type="card"
          activeKey={subTab}
          items={[
            {
              label: <p>{t("Most Recent")}</p>,
              key: "tabMos",
            },
          ]}
        />
        {subTab === "tabMos" && (
          <div>
            <div className="flex flex-col ">
              <div className="flex flex-col space-y-2 max-h-[200px] overflow-y-auto p-[10px] flex-1 border border-1">
                {mostRecentPages.map((item, index) => (
                  <Checkbox
                    key={index}
                    checked={checkedItems.includes(item.name)}
                    onChange={e => handleCheckboxChange(e as any, item.name)}
                  >
                    {item.name}
                  </Checkbox>
                ))}
              </div>
            </div>
            <div className="flex justify-between py-[10px] items-center">
              <Checkbox
                onClick={handlePageSelectAll}
                checked={mostRecentPages.every(page => checkedItems.includes(page.name))}
              >
                {t("Select All")}
              </Checkbox>
              <Button onClick={addToMenu}>{t("Add to menu")}</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PagesItem
